/* ============================================================
   VAMORA homepage — shared, idempotent controller.
   Only two behaviours: scroll reveal + shop-the-look hotspots.
   Everything commerce (cards, quick-add, cart, search, drawer,
   newsletter form) is native Horizon / Shopify. Theme-Editor safe:
   re-scans on shopify:section:load, one shared observer, no dupes.
   ============================================================ */
(function () {
  "use strict";
  if (window.__vamoraHome) return;
  window.__vamoraHome = true;

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Reveal ---------- */
  var observer = null;
  function ensureObserver() {
    if (observer || reduce || !("IntersectionObserver" in window)) return;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("vh-in"); observer.unobserve(e.target); }
      });
    }, { rootMargin: "0px 0px -8% 0px" });
  }
  function scanReveal(root) {
    var scope = root || document;
    var items = scope.querySelectorAll(".vamora-home [data-vh-reveal]:not(.vh-in)");
    if (reduce || !("IntersectionObserver" in window)) {
      items.forEach(function (el) { el.classList.add("vh-in"); });
      return;
    }
    ensureObserver();
    items.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Shop the look ---------- */
  function selectHotspot(btn) {
    var stage = btn.closest(".vh-look");
    if (!stage) return;
    stage.querySelectorAll("[data-vh-look-btn]").forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
    stage.querySelectorAll("[data-vh-look-panel]").forEach(function (p) { p.hidden = true; });
    btn.setAttribute("aria-expanded", "true");
    var panel = stage.querySelector("#" + btn.getAttribute("aria-controls"));
    if (panel) panel.hidden = false;
  }
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-vh-look-btn]");
    if (btn) { e.preventDefault(); selectHotspot(btn); }
  });

  /* ---------- Init + Theme Editor lifecycle ---------- */
  function init(root) { scanReveal(root); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { init(); });
  else init();
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();
